<template>
  <div>
    <div :class="`d-flex flex-row justify-content-between align-items-center ${progressPaddingClass}`">
      <div v-if="labelTextMin !== ''" class="flex-item">
        <p class="text-small mb-2">{{ labelTextMin }}</p>
      </div>
      <b-progress 
          :value="progressValue" 
          :max="progressValueMax" 
          :class="`flex-grow-1 ${progressMargingClass}`"
          :variant="progressValue < 100 ? 'primary' : 'success'" animated>
      </b-progress>
      <div v-if="labelTextMax !== ''" class="flex-item">
        <p class="text-small mb-2">{{ labelTextMax }}</p>
      </div>
    </div>
    <p class="text-small text-center mx-4">{{ labelText }}</p>
  </div>
</template>

<script>
export default {
  props: {
    progressMargingClass: {
      type: String,
      default: ''
    },
    progressPaddingClass: {
      type: String,
      default: ''
    },
    labelText: {
      type: String, 
      default: ''
    },
    labelTextMin: {
      type: String, 
      default: ''
    },
    labelTextMax: {
      type: String, 
      default: ''
    },
    progressValue: {
      type: Number,
      default: 0
    },
    progressValueMax: {
      type: Number,
      default: 100
    },
    progressBarColor: {
      type: String,
      default: 'primary'
    }
  },
  data() {
    return {
      
    }
  },
  computed: {

  },
  methods: {

  }
}
</script>